import {
  Shield, Home, Info, Handshake, Check, Clock, Users, Calculator,
  ExternalLink, HelpCircle, AlertCircle, CreditCard, Percent, FileText,
  Heart, Star, Gift, Mail, Phone, Calendar, CheckCircle
} from 'lucide-react';

// Built-in icon library (name -> lucide component). Admin can also upload custom icons.
export const SAP_ICONS = {
  shield: Shield, home: Home, info: Info, handshake: Handshake, check: Check,
  clock: Clock, users: Users, calculator: Calculator, 'external-link': ExternalLink,
  'help-circle': HelpCircle, 'alert-circle': AlertCircle, 'credit-card': CreditCard,
  percent: Percent, 'file-text': FileText, heart: Heart, star: Star, gift: Gift,
  mail: Mail, phone: Phone, calendar: Calendar, 'check-circle': CheckCircle,
};

export const SAP_ICON_NAMES = Object.keys(SAP_ICONS);
